import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { BsPerson } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const InvoiceSummaryModal = ({ show, onHide, customer, currency, amount, searchParams, updateInvoices, createInvoice, getValues, setStoredValues, otherArticlesData }) => {
    const { t } = useTranslation();

    const calculateTotalUploadSize = () => {
        let totalBytes = 0;

        const invoiceFiles = getValues().invoiceFile;
        if (invoiceFiles) {
            Object.values(invoiceFiles).forEach(fileList => {
                if (fileList && fileList[0] instanceof File) {
                    totalBytes += fileList[0].size;
                }
            });
        }

        if (otherArticlesData) {
            Object.values(otherArticlesData).forEach(articleGroup => {
                if (Array.isArray(articleGroup)) {
                    articleGroup.forEach(article => {
                        const uploadFile = article?.data?.uploadFile;
                        if (uploadFile && uploadFile[0] instanceof File) {
                            totalBytes += uploadFile[0].size;
                        }
                    });
                }
            });
        }

        return totalBytes;
    };
    return (
        <Modal show={show} onHide={onHide} className="center" style={{ marginTop: '100px' }}>
            <Modal.Header>
                <Modal.Title>
                    {t('Summary')}
                    <h6 className="m-0 text-primary-custom">
                        {t('You are about to create an invoice with the following information')}
                    </h6>
                </Modal.Title>
                <AiOutlineClose className="ml-auto cursor-pointer" size={24} onClick={onHide} />
            </Modal.Header>
            <Modal.Body className="bg-secondary-custom">
                <div className="d-flex align-items-center mx-4 my-3">
                    <BsPerson size={36} />
                    <h6 className="m-0 ml-4">{customer?.name}</h6>
                </div>
                <div className="d-flex align-items-center mx-4 my-3">
                    <div className="infolist-icon">
                        <p className="m-0">{currency}</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width={36} height={36} viewBox="0 0 20 20">
                            <path d="M19 17.55H1a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h18a.5.5 0 0 1 .5.5v10c0 .275-.225.5-.5.5zm-17.5-1h17v-9h-17v9zM18 5.55H2a.5.5 0 0 1 0-1h16a.5.5 0 0 1 0 1zM17 3.55H3a.5.5 0 0 1 0-1h14a.5.5 0 0 1 0 1z" />
                        </svg>
                    </div>
                    <h6 className="m-0 ml-4">
                        {currency} {amount} {t('ex.')} {t('VAT')}
                    </h6>
                </div>
                <div className="d-flex align-items-center mx-4 my-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width={36} height={36} viewBox="0 0 20 20">
                        <path d="M10.5 0h-4a.5.5 0 0 0-.5.5v5.586c-.582.206-1 .762-1 1.414C5 8.327 5.673 9 6.5 9S8 8.327 8 7.5c0-.652-.418-1.208-1-1.414V3h3.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm-4 8a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM10 2H7V1h3v1z" />
                        <path d="M19.088 6.945c-.354-.916-.818-1.628-1.38-2.118a3.303 3.303 0 0 0-2.234-.826H8.5a.5.5 0 0 0 0 1h6.974c2.79 0 3.469 4.236 3.522 8H2.999v-8h1.5a.5.5 0 0 0 0-1h-1.5v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-.5h5v5.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-5.5h7.5a.5.5 0 0 0 .5-.5c0-2.785-.307-4.99-.912-6.555zM2 14H1V4h1v10zm9 5H9v-5h2v5z" />
                    </svg>
                    <h6 className="m-0 ml-4">
                        {t('Email')} {customer?.email}
                    </h6>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('Cancel')}
                </Button>
                <Button
                    className="text-light"
                    variant="primary"
                    onClick={() => {
                        const totalBytes = calculateTotalUploadSize();
                        if (totalBytes / (1024 * 1024) > 20) {
                            toast.error(t('Total uploaded file size cannot exceed 20 MB.'));
                            return;
                        }
                        (searchParams?.size >= 1 ? updateInvoices(getValues()) : createInvoice(getValues()));
                        setStoredValues(getValues());
                    }}
                >
                    {searchParams?.size >= 1 ? t('Update invoice') : t('Create invoice')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InvoiceSummaryModal;